import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b938c068&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b938c068')) {
      api.createRecord('b938c068', component.options)
    } else {
      api.reload('b938c068', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b938c068&", function () {
      api.rerender('b938c068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xK9BRlRhAyvI/JS/comp/DateRangeExt.vue"
export default component.exports